import { isNil } from 'lodash-es';

// 取整方法
export const keepZeroOrLine = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(0);
  } else {
    return '--';
  }
};

export const keepFeeZeroOrLine = (data?: number) => {
  if (!isNil(data)) {
    return Number(data.toFixed(0)).toLocaleString();
  } else {
    return '--';
  }
};

export const keepOneOrLine = (data?: number | string) => {
  if (!isNil(data)) {
    return Number(data).toFixed(1);
  } else {
    return '--';
  }
};
export const keepOneAndWanOrLine = (data?: number) => {
  if (!isNil(data)) {
    if (data >= 100000) {
      // 除以 10000，保留 2 位小数，去掉多余的 .00
      return (data / 10000).toFixed(1).replace(/\.00$/, '') + '万';
    }
    return data.toFixed(1);
  } else {
    return '--';
  }
};

export const keepTwoOrLine = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return '--';
  }
};
export const keepTwoOrEmpty = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return '';
  }
};

export const keepOneNull = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(1);
  } else {
    return '--';
  }
};

export const keepTwoNull = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return '--';
  }
};
export const keepFourOrNull = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(4);
  } else {
    return null;
  }
};
export const keepFourOrLine = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(4);
  }
};

export const keepZeroPercentOrLine = (data?: number): string => {
  if (!isNil(data)) {
    return (data * 100).toFixed(0);
  } else {
    return '--';
  }
};

export const keepOnePercentOrLine = (data?: number | string): string => {
  if (!isNil(data)) {
    return (Number(data) * 100).toFixed(1);
  } else {
    return '--';
  }
};

export const keepPercentOrLine = (data?: number): string => {
  if (!isNil(data)) {
    return (data * 100).toFixed(2);
  } else {
    return '--';
  }
};

export function formatPercentWithoutSign(rate?: number | null): string {
  if (rate === null || rate === undefined) return '--';
  const val = Math.abs(rate);
  return keepZeroPercentOrLine(val);
}

export const keepPercentTwoUndfined = (data?: number): number | undefined => {
  if (!isNil(data)) {
    return Number((data * 100).toFixed(2));
  } else {
    return undefined;
  }
};

export const keepPercentOneUndfined = (data?: number): number | undefined => {
  if (!isNil(data)) {
    return Number((data * 100).toFixed(1));
  } else {
    return undefined;
  }
};

export const keepPercentTwoNull = (data?: number): number | null => {
  if (!isNil(data)) {
    return Number((data * 100).toFixed(2));
  } else {
    return null;
  }
};

export function formatPowerKWh(value?: number): string {
  if (value == null) return '--';
  if (value >= 100000) {
    return (value / 10000).toFixed(0) + '万';
  }
  return Math.round(value).toString();
}

/**
 * 单位转换（kg->t）
 * @param value 数值
 * @param fixed 保留小数位（默认 2）
 * @returns 格式化后的字符串
 */
export function formatKgToTonUnit(value?: string | number, fixed: number = 1): { value: string; unit: string } {
  if (value == null)
    return {
      value: '--',
      unit: '',
    };
  if (typeof value === 'string') {
    value = Number(value);
  }

  const absVal = Math.abs(value);

  if (absVal >= 1000) {
    return {
      value: (value / 1000).toFixed(fixed),
      unit: 't',
    };
  }
  return {
    value: value.toFixed(fixed),
    unit: 'kg',
  };
}
// 格式化金额
export function formatThousandAndUnit(
  value?: string | number,
  fixed: number = 1,
  isInterger: boolean = false
): { value: string; unit: string } {
  if (value == null)
    return {
      value: '--',
      unit: '',
    };
  if (typeof value === 'string') {
    value = Number(value);
  }
  let absVal = Math.abs(value);
  if (isInterger) {
    absVal = Number(Math.abs(value).toFixed(0));
  }

  if (absVal >= 10000) {
    return {
      value: (value / 10000).toFixed(fixed),
      unit: '万',
    };
  }
  return {
    value: value.toFixed(isInterger ? 0 : fixed),
    unit: '',
  };
}

export const keepValueOrLine = (data?: number): any => {
  if (isNil(data)) {
    return '--';
  } else {
    return data;
  }
};
